import { Box, Heading, HStack, Pressable, VStack } from 'native-base';
import React, { ReactNode } from 'react';

import RadioIndicator from 'app/components/RadioIndicator';
import { tID } from 'app/services/TestHelper';

export type RadioButtonCardProps = {
  isSelected: boolean;
  value: string;
  title: string;
  children?: ReactNode;
  onPress: () => void;
  testID?: string;
};

export default function RadioButtonCard({
  isSelected,
  value,
  title,
  children,
  onPress,
  testID,
}: RadioButtonCardProps) {
  return (
    <Pressable
      accessibilityLabel={title || value}
      accessibilityRole="radio"
      accessibilityState={{ checked: isSelected }}
      testID={tID(testID || 'RadioButtonCard')}
      w="full"
      onPress={onPress}
    >
      <HStack
        bg={isSelected ? 'brand.activeBg' : undefined}
        borderColor={isSelected ? 'brand.active' : 'gray.300'}
        borderWidth="2"
        p="3"
        rounded="md"
        space="3"
      >
        <Box pointerEvents="none">
          <RadioIndicator isSelected={isSelected} />
        </Box>
        <VStack flex="1" space="2">
          <Heading mt="3px" size="sm">
            {title}
          </Heading>
          {children && <Box>{children}</Box>}
        </VStack>
      </HStack>
    </Pressable>
  );
}
